/* 🤖 this file was generated by svg-to-ts */
export const matIconHorizontalSplit: {
  name: 'horizontal-split';
  data: string;
} = {
  name: 'horizontal-split',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z"/></svg>`
};
